import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import datePicker from '../../component/dccore-form/datePicker.vue'
import moment from 'moment'
import axios from 'axios'
import ratingReport from './ratingReport.vue'
import JsonExcel from 'vue-json-excel'

require('bootstrap')

if ($('#rating_report').length) {
  Vue.use(VueResource)
  Vue.component('DownloadExcel', JsonExcel)
  new Vue({
    el: '#rating_report',
    components: {
      datePicker,
      ratingReport
    },
    mixins: [mixins],
    data: {
      dateFrom: moment().locale('pl').format('YYYY-MM-DD'),
      dateTo: moment().locale('pl').format('YYYY-MM-DD'),
      meals: [],
      isGenerating: false,
      isGenerated: false,
      length: 0,
      buttonsDisabled: false,
      form: {
        options: {
          errors: {},
        }
      },
    },
    watch: {
      dateFrom: function() {
        this.validateDate()
      },
      dateTo: function() {
        this.validateDate()
      }
    },
    methods: {
      validateDate() {
        const toDate = new Date(this.dateTo)
        const fromDate = new Date(this.dateFrom)
        if (toDate < fromDate) {
          this.buttonsDisabled = true
          this.form.options.errors = { dateTo: Translator.trans('form.errors.date_to_must_be_equal_greater') }
        } else {
          this.buttonsDisabled = false
          this.form.options.errors = {}
        }
      },
      async generateReport() {
        this.$refs.ratingReport.resetState()
        this.isGenerating = true
        let url = Routing.generate('generate_report', {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        })
        const response = await axios.get(
          url, {}
        )
        this.meals = response.data
        this.isGenerating = false
        this.isGenerated = true
        this.length = this.meals.length
      }
    }
  })
}
